import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

export type SmsTextRef = {
	ZaznamId: number,
	Text: string,
	SmsTypPzn: number,
	LanguageId: number,
	PozdravText: string,
};

export type SSmsDynText = {
	ZaznamId: number,
	DynZnac: string,
	Text: string,
	SmsTypPzn: number,
};

export type UserMessage = {
	Title: string,
	Message: string,
	Type: number,
};

const edit = {
	ZaznamId: null as number | null,
	Text: null as string | null,
	SmsTypPzn: null as number | null,
	Activated: null as boolean | null,
	EditDat: null as Date | null,
	EditPracId: null as number | null,
	VstupDat: null as Date | null,
	VstupPracId: null as number | null,
	Poznamka: null as string | null,
	PozdravText: null as string | null,
	SmsDynText: null as number | null,
	SmsTextRefList: null as SmsTextRef[] | null,
	SSmsDynTextList: null as SSmsDynText[] | null,
	UserMessageList: null as UserMessage[] | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		SmsTypPzn: [],
	},
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
